import React from 'react'
import { useReactiveVar } from '@apollo/client'
import { Box } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { BuildingFragment } from '../../generated/graphql'
import { ResultsByBuildingAccordion } from './ResultsByBuildingAccordion'
import { calculatorVar } from '../../apollo/reactive-vars'
import { buildingResultCategories } from '../../provider/result-categories'
import { getFilteredResultsFromContainers } from '../../calculators/calculator-result-utility'

type Props = {
  buildings: BuildingFragment[]
}

export function ResultsByBuilding({ buildings }: Props): React.ReactElement {
  const { t } = useTranslation()
  const calculator = useReactiveVar(calculatorVar)

  if (!calculator) {
    return <Box />
  }

  return (
    <Box>
      {buildingResultCategories.map((category) => (
        <ResultsByBuildingAccordion
          key={category.nameKey}
          title={t(category.nameKey)}
          buildings={buildings}
          columns={category.subCategories.map((subCategory) => ({
            title: t(subCategory.nameKey),
            valueGetter: (buildingId) =>
              getFilteredResultsFromContainers(
                subCategory,
                calculator
                  .getMultipliedBuildings()
                  .filter(
                    (buildingCalculator) =>
                      buildingCalculator.id === buildingId,
                  ),
              ).total,
          }))}
        />
      ))}
    </Box>
  )
}
